interface SearchResultMetadataState {
  hasError: boolean;
  hasResolved: boolean;
  hasResults: boolean;
  isLoading: boolean;
}

export const getSearchResultRobotsMeta = ({
  hasError,
  hasResolved,
  hasResults,
  isLoading,
}: SearchResultMetadataState) =>
  hasResolved && !isLoading && !hasError && !hasResults
    ? { robots: 'noindex, follow' }
    : undefined;
